import angular, { ITemplateCacheService } from 'angular';
import { dirtyfields } from '../../tn.common';
import { CartRepository } from '../cart-repository.service/cartRepository';
import { CartService } from '../service.tn.cart';
import emailNewCartTemplate from './email-new-cart.html';

export function populateTemplateCache($templateCache: ITemplateCacheService): void {
    // inject into template cache for reuse.
    $templateCache.put(
        'email-cart.view/email-new-cart.html',
        emailNewCartTemplate
    );
}
populateTemplateCache.$inject = ['$templateCache'];

EmailCartController.$inject = ['$scope', 'cartRepository', 'tn.cart.service'];
export function EmailCartController(
    $scope,
    cartRepository: CartRepository,
    cartService: CartService
) {
    const vm = angular.extend(this, {
        states: {
            // tn.ui/partials injected into $templateCache by module.tn.ui.js
            'email-new-cart': {
                templateUrl: 'email-cart.view/email-new-cart.html',
            },
            email: {
                templateUrl: 'tn.ui/partials/email-popover.html',
            },
            'email-sent': {
                templateUrl: 'tn.ui/partials/email-sent.html',
            },
        },
        currentState: 'email',
        heading: 'Email Cart',
        subheading: 'Please provide the email to send the saved cart',

        sendEmail: sendEmail,
        saveSendEmail: saveSendEmail,
        showEmailForm: showEmailForm,
    });

    function showEmailForm() {
        vm.currentState = 'email';
        vm.email = null;
        vm.title = null;
    }

    function sendEmail() {
        if (vm.sendForm.$valid) {
            const cart = $scope.$parent.vm.cart;
            return cartRepository
                .emailSavedCart(vm.email, cart.id)
                .then(function () {
                    vm.currentState = 'email-sent';
                });
        } else {
            dirtyfields(vm.sendForm);
        }
    }

    function saveSendEmail() {
        if (vm.sendForm.$valid) {
            return cartService
                .saveCartToServer(vm.title)
                .then(function (result) {
                    vm.currentState = 'email-sent';
                    cartRepository.emailSavedCart(vm.email, result.id);
                });
        } else {
            dirtyfields(vm.sendForm);
        }
    }
}
